var _circle, _rect, _line, _rect2, _rect3, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatEmpresarialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#502887"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.98938,
    y: 8.85901,
    width: 10.3191,
    height: 12.9487,
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.0975,
    y1: 22.017,
    x2: 14.0975,
    y2: 3.99996,
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.644,
    y: 6.52142,
    width: 5.25532,
    height: 1.90597,
    stroke: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6702,
    y: 19.9017,
    width: 5.25532,
    height: 1.90597,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 21.8077,
    x2: 21,
    y2: 21.8077,
    stroke: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14.4468,
    y1: 17.4487,
    x2: 17.4255,
    y2: 17.4487,
    stroke: "white"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 14.4468,
    y1: 15.4144,
    x2: 17.4255,
    y2: 15.4144,
    stroke: "white"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 14.4468,
    y1: 13.671,
    x2: 17.4255,
    y2: 13.671,
    stroke: "white"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 14.4468,
    y1: 11.6367,
    x2: 17.4255,
    y2: 11.6367,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatEmpresarialIcon);
export default __webpack_public_path__ + "static/media/chat-empresarial-icon.137d15ab.svg";
export { ForwardRef as ReactComponent };